// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Credits.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  AdjustCreditsRequest,
  AdjustCreditsResponse,
  GetCreditAccountRequest,
  GetCreditAccountResponse,
  GetCreditTransactionsRequest,
  GetCreditTransactionsResponse,
  PurchaseCreditsRequest,
  PurchaseCreditsResponse,
  SetMultipliersRequest,
  SetMultipliersResponse,
} from "./Models/CreditModels";

export const protobufPackage = "daisi.protos.v1";

export type CreditsProtoDefinition = typeof CreditsProtoDefinition;
export const CreditsProtoDefinition = {
  name: "CreditsProto",
  fullName: "daisi.protos.v1.CreditsProto",
  methods: {
    getCreditAccount: {
      name: "GetCreditAccount",
      requestType: GetCreditAccountRequest,
      requestStream: false,
      responseType: GetCreditAccountResponse,
      responseStream: false,
      options: {},
    },
    getCreditTransactions: {
      name: "GetCreditTransactions",
      requestType: GetCreditTransactionsRequest,
      requestStream: false,
      responseType: GetCreditTransactionsResponse,
      responseStream: false,
      options: {},
    },
    setMultipliers: {
      name: "SetMultipliers",
      requestType: SetMultipliersRequest,
      requestStream: false,
      responseType: SetMultipliersResponse,
      responseStream: false,
      options: {},
    },
    purchaseCredits: {
      name: "PurchaseCredits",
      requestType: PurchaseCreditsRequest,
      requestStream: false,
      responseType: PurchaseCreditsResponse,
      responseStream: false,
      options: {},
    },
    adjustCredits: {
      name: "AdjustCredits",
      requestType: AdjustCreditsRequest,
      requestStream: false,
      responseType: AdjustCreditsResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface CreditsProtoServiceImplementation<CallContextExt = {}> {
  getCreditAccount(
    request: GetCreditAccountRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetCreditAccountResponse>>;
  getCreditTransactions(
    request: GetCreditTransactionsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetCreditTransactionsResponse>>;
  setMultipliers(
    request: SetMultipliersRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<SetMultipliersResponse>>;
  purchaseCredits(
    request: PurchaseCreditsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<PurchaseCreditsResponse>>;
  adjustCredits(
    request: AdjustCreditsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<AdjustCreditsResponse>>;
}

export interface CreditsProtoClient<CallOptionsExt = {}> {
  getCreditAccount(
    request: DeepPartial<GetCreditAccountRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetCreditAccountResponse>;
  getCreditTransactions(
    request: DeepPartial<GetCreditTransactionsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetCreditTransactionsResponse>;
  setMultipliers(
    request: DeepPartial<SetMultipliersRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<SetMultipliersResponse>;
  purchaseCredits(
    request: DeepPartial<PurchaseCreditsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<PurchaseCreditsResponse>;
  adjustCredits(
    request: DeepPartial<AdjustCreditsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<AdjustCreditsResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
